export enum ReCaptchaEnum {
  CHECK = 1,
  ANDROID = 2,
  INVISIBLE = 3,
}
